import { useProgress, type SyncStatus } from '../state/ProgressContext'
import { Icon } from './Icon'

const labels: Record<SyncStatus, string> = {
  guest: 'Saved on this device',
  saved: 'Saved',
  syncing: 'Syncing',
  'saved-device': 'Saved on this device',
  retrying: 'Retrying sync',
  'sign-in': 'Sign in again',
}

export function SyncBadge() {
  const { syncStatus } = useProgress()
  return (
    <span className={`sync-badge sync-${syncStatus}`} title={syncStatus === 'guest' ? 'Guest progress stays in this browser.' : labels[syncStatus]}>
      {syncStatus === 'saved' ? <Icon name="check" size={14} /> : <Icon name="sync" size={14} />}
      {labels[syncStatus]}
    </span>
  )
}
